import BaseModel from '../BaseModel';

export default class Settings extends BaseModel {
  static entity = 'companySettings';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      companyId: this.attr(null),
      showDashboardTip: this.boolean(true),
      companyAboutFilled: this.boolean(false),
      vacanciesAdded: this.boolean(false),
      candidatesInvited: this.boolean(false),
      interviewsViewed: this.boolean(false),
      autoInvitation: this.boolean(false),
      notificationMethod: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      async update(companyId, payload) {
        return this.put(`companies/${companyId}/settings`, payload);
      },
    },
  }
}
